import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AcmHttpResponse } from '../models/acm-http';
import { FEEDBACK_API_ACTIONS, FEEDBACK_SOURCE, FEEDBACK_SHORT_DESCRIPTION, FEEDBACK_FORM_TYPE, FeedbackModel } from '../models/feedback';


@Injectable({
  providedIn: 'root'
})
export class FeedbackService {

  constructor(private httpClient: HttpClient) { }

  public sendFeedback(feedbackForm: FeedbackModel): Observable<AcmHttpResponse> {
    feedbackForm.feedbackSource = FEEDBACK_SOURCE.ADMIN;

    return this.httpClient.post(
      `${environment.apiUrl}${FEEDBACK_API_ACTIONS.CREATE}`,
      feedbackForm,
      {observe: 'response'})
      .pipe(
        map((response: HttpResponse<{}>): AcmHttpResponse => ({statusCode: response.status}))
      ) as Observable<AcmHttpResponse>;
  }

  public getFeedback(feedbackSource: FEEDBACK_API_ACTIONS.GET_ADMIN | FEEDBACK_API_ACTIONS.GET_CLIENT | FEEDBACK_API_ACTIONS.GET_ALL_FEEDBACK): Observable<FeedbackModel[]> {
    const url = `${environment.apiUrl}${FEEDBACK_API_ACTIONS.GET_ALL_FEEDBACK}${feedbackSource === FEEDBACK_API_ACTIONS.GET_ALL_FEEDBACK ? '' : '/' + feedbackSource}`;

    return this.httpClient.get(url).pipe(
      catchError(() => of([])),
      map((feedback: FeedbackModel[]): FeedbackModel[] => {
        return this.updatedFeedbackModel(feedback);
      })
    );
  }

  public getFeedbackBySn(smartNumber: string, feedbackSource: FEEDBACK_API_ACTIONS.GET_ADMIN | FEEDBACK_API_ACTIONS.GET_CLIENT | string = '')
    : Observable<FeedbackModel[]> {
    return this.httpClient.get(`${environment.apiUrl}${FEEDBACK_API_ACTIONS.GET_PRODUCT_FEEDBACK}/${smartNumber}/${feedbackSource}`).pipe(
      catchError(() => of([])),
      map((feedback: FeedbackModel[]): FeedbackModel[] => {
        return this.updatedFeedbackModel(feedback);
      })
    );
  }

  private updatedFeedbackModel(feedback: FeedbackModel[]): FeedbackModel[] {
    if (!feedback) {
      return [];
    }

    return feedback.map((currentFeedback: FeedbackModel): FeedbackModel => ({
      ...currentFeedback,
      shortDescription: currentFeedback.shortDescription.map((sd: FEEDBACK_SHORT_DESCRIPTION | string): string => {
        return sd.replace(/_/g, ' ');
      }),
      feedbackType: currentFeedback.negative ? FEEDBACK_FORM_TYPE.NEGATIVE : FEEDBACK_FORM_TYPE.POSITIVE
    }));
  }
}
